import createReactComponent from '../createReactComponent';
var BoxSelect = createReactComponent('BoxSelect', [['path', {
  d: 'M4 2a2 2 0 00-2 2',
  key: '4k7ex9'
}], ['line', {
  x1: '8',
  y1: '2',
  x2: '10',
  y2: '2',
  key: 'kyzuqa'
}], ['line', {
  x1: '14',
  y1: '2',
  x2: '16',
  y2: '2',
  key: 'fiq0bt'
}], ['path', {
  d: 'M4 22a2 2 0 01-2-2',
  key: '1qyln8'
}], ['line', {
  x1: '22',
  y1: '8',
  x2: '22',
  y2: '10',
  key: '1v1it1'
}], ['line', {
  x1: '22',
  y1: '14',
  x2: '22',
  y2: '16',
  key: 'spbgq1'
}], ['path', {
  d: 'M22 20a2 2 0 01-2 2',
  key: '1g0x72'
}], ['line', {
  x1: '14',
  y1: '22',
  x2: '16',
  y2: '22',
  key: '4eek89'
}], ['line', {
  x1: '8',
  y1: '22',
  x2: '10',
  y2: '22',
  key: '1o1cll'
}], ['path', {
  d: 'M20 2a2 2 0 012 2',
  key: '1yskek'
}], ['line', {
  x1: '2',
  y1: '14',
  x2: '2',
  y2: '16',
  key: 'wdgxmx'
}], ['line', {
  x1: '2',
  y1: '8',
  x2: '2',
  y2: '10',
  key: '148fce'
}]]);
export default BoxSelect;